import { render, staticRenderFns } from "./lkuLeave.vue?vue&type=template&id=40ba790a"
import script from "./lkuLeave.vue?vue&type=script&lang=js"
export * from "./lkuLeave.vue?vue&type=script&lang=js"
import style0 from "./lkuLeave.vue?vue&type=style&index=0&id=40ba790a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports